/**
 * DealNotFound — the ONE view for a deal address that names no deal here
 * (deal detail slice 9, R9): an unknown id, another tenant's id (the server
 * answers both with the same 404) and a malformed id (never sent) all read
 * the same plain sentence. It never shows the id, nor the server's text.
 */
export function DealNotFound({ onBackToPipeline }: { onBackToPipeline?: () => void }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center gap-3" data-deal-not-found>
      <h1 className="text-section-title font-semibold text-ink-primary">Deal not found</h1>
      <p className="text-13 text-ink-secondary max-w-[420px]">
        No deal in this workspace matches this link. It may have been deleted, or the link may be incomplete.
      </p>
      {onBackToPipeline && (
        <button type="button" className="k-btn-secondary" onClick={onBackToPipeline}>Back to the pipeline</button>
      )}
    </div>
  )
}
